import {StateService} from '@uirouter/core';

export class StatusPanelController implements angular.IController {
  public tracking;
  public podeAbrirChamado = false;
  public loading = false;

  constructor(private $rootScope: angular.IScope, private $mdToast, public data, private Perfil, private mdPanelRef,
              private $state: StateService, private AtendimentoResource) {
    'ngInject';

    this.tracking = data.rastreamento;
  }

  public async $onInit() {
    const data = await this.Perfil.getBetaFeatures();
    const aberturaChamado = data.funcionalidades.find(f => f.codigo === 'abertura-chamado');
    this.podeAbrirChamado = aberturaChamado && aberturaChamado.possuiAcesso;
  }

  public isAddressDivergence() {
    if (!this.data.rastreamentoRemessa) {
      return false;
    }

    return [
      'Endereço incorreto - CEP do destinatário',
      'Endereço incorreto - UF do destinatário',
      'Endereço incorreto - Bairro do destinatário',
      'Endereço incorreto - Número do endereço',
      'Endereço incorreto - Logradouro do destinatário',
    ].includes(this.data.rastreamentoRemessa.descricaoEvento);
  }

  public isInvoiceDivergence() {
    if (!this.data.rastreamentoRemessa) {
      return false;
    }

    return [
      'Documento fiscal divergente ou inválido',
      'Documento fiscal cancelado',
      'Documento fiscal não registrado',
      'Documento fiscal anexado de forma incorreta',
      'Falha ao ler o documento fiscal',
      'Sem documento fiscal impresso',
      'Chave do documento fiscal impresso é diferente da chave cadastrada'
    ].includes(this.data.rastreamentoRemessa.descricaoEvento);
  }

  public openEditPanel() {
    this.$rootScope.$emit('editPanel:show', Object.assign({}, this.data));
  }

  public closePanel() {
    if (!this.mdPanelRef) {
      return;
    }
    this.$rootScope.$emit('reload');
    this.mdPanelRef.close();
  }

  public async openTicketForm() {
    if (!this.mdPanelRef) {
      return;
    }

    await this.mdPanelRef.close();

    this.$rootScope.$emit('ticket_form:show', {
      id: this.data.id,
      trackingCode: this.data.rastreamento.codigoMandae,
      shipping: this.data.frete.nomeTransportadora,
      incident: this.data.rastreamentoRemessa.descricaoEvento,
      trackingUrl: this.tracking.url,
      extras: '',
      appendText: this.data.rastreamentoRemessa.complemento,
    });
  }

  public verifyShowEdit() {
    return this.isAddressDivergence() || this.isInvoiceDivergence();
  }

  showAlert(content) {
    const toast = this.$mdToast.simple()
      .textContent(content)
      .highlightAction(true)
      .parent('[data-container="toast"]')
      .position('top right')
      .hideDelay(5000);

    return this.$mdToast.show(toast);
  }

  public async openTicket() {
    this.loading = true;
    try {
      const ticketsResponse = await this.AtendimentoResource.query({
        trackingCode: this.data.rastreamento.codigoMandae
      }).$promise;
      if (ticketsResponse.tickets.length > 0) {
        this.$state.go('relacionamentodetalhes', {ticketId: ticketsResponse.tickets[0].id});
      } else {
        this.$mdToast.show(
          this.$mdToast.simple().textContent('Nenhuma solicitação para a ocorrência').position('top right'));
      }
    } catch {
      this.$mdToast.show(
        this.$mdToast.simple().textContent('Erro ao exibir solicitação').position('top right'));
    } finally {
      this.loading = false;
      this.mdPanelRef.close();
    }
  }
}
